import { DvToolbarAction, DvToolbarActionEvent } from '@devinco/ui/grid';
import { Injectable } from '@angular/core';
import { ColumnType } from '@features/vt-grid/grid-options/column-types';
import { vtPresetActions } from '@features/vt-grid/presets/preset-actions';
import { ColDef } from 'ag-grid-community';

@Injectable()
export class TripTypeSetupGridService {
  colDefs: ColDef[] = [
    {
      field: 'From',
      headerName: 'TripTypeSetupGrid.From',
      type: [ColumnType.Text],
    },
    {
      field: 'To',
      headerName: 'TripTypeSetupGrid.To',
      type: [ColumnType.Text],
    },
    {
      field: 'Monday',
      headerName: 'General.DaysOfWeek.Monday',
      type: [ColumnType.Checkbox],
      width: 100,
    },
    {
      field: 'Tuesday',
      headerName: 'General.DaysOfWeek.Tuesday',
      type: [ColumnType.Checkbox],
      width: 100,
    },
    {
      field: 'Wednesday',
      headerName: 'General.DaysOfWeek.Wednesday',
      type: [ColumnType.Checkbox],
      width: 100,
    },
    {
      field: 'Thursday',
      headerName: 'General.DaysOfWeek.Thursday',
      type: [ColumnType.Checkbox],
      width: 100,
    },
    {
      field: 'Friday',
      headerName: 'General.DaysOfWeek.Friday',
      type: [ColumnType.Checkbox],
      width: 100,
    },
    {
      field: 'Saturday',
      headerName: 'General.DaysOfWeek.Saturday',
      type: [ColumnType.Checkbox],
      width: 100,
    },
    {
      field: 'Sunday',
      headerName: 'General.DaysOfWeek.Sunday',
      type: [ColumnType.Checkbox],
      width: 100,
    },
  ];

  getToolbarActions(
    editFn: (event?: DvToolbarActionEvent) => void,
    addFn: (event?: DvToolbarActionEvent) => void,
    reloadFn: () => void,
    deleteFn: (event?: DvToolbarActionEvent) => void
  ): DvToolbarAction[] {
    return [
      vtPresetActions.reset,
      vtPresetActions.fit,
      { ...vtPresetActions.reload, clickFn: reloadFn },
      vtPresetActions.excel,
      {},
      {
        icon: 'edit',
        clickFn: (event: DvToolbarActionEvent) => editFn(event),
        disabled: true,
        tooltipKey: 'Grid.Edit',
      },
      {
        icon: 'delete',
        disabled: true,
        clickFn: (event: DvToolbarActionEvent) => deleteFn(event),
        tooltipKey: 'Grid.Delete',
      },
      {
        icon: 'add_box',
        tooltipKey: 'Grid.Add',
        clickFn: (event: DvToolbarActionEvent) => addFn(event),
      },
    ];
  }
}
